import {useState} from 'react';

import {CollapseExpandAnimation} from 'shells/animation/collapse-expand-animation';
import {Button} from 'shells/button/button';
import {Stack} from 'shells/layout/stack/stack';

import type {
    OnboardingModuleFragment,
    UserEmailCalendarStatusesFragment,
    UserVideoIntegrationsFragment,
} from 'nutshell-graphql-types';

import {OnboardingModule} from './onboarding-module';

type Props = {
    hiddenModules: OnboardingModuleFragment[];
    hasFullSchedulerAccess: boolean;
    userEmailCalendarStatuses: UserEmailCalendarStatusesFragment | null | undefined;
    userVideoIntegrations: UserVideoIntegrationsFragment | null | undefined;
    hasClickToCallConnected: boolean;
    hasPhoneIntegrationConnected: boolean;
    onEmailCalendarAuthSuccess?: (provider: 'google' | 'microsoft') => void;
};

export function HiddenModulesSection(props: Props) {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    if (props.hiddenModules.length === 0) {
        return null;
    }

    const pluralization = props.hiddenModules.length > 1 ? 's' : '';
    const toggleLabel = isExpanded
        ? `Hide ${props.hiddenModules.length} booster${pluralization}`
        : `View ${props.hiddenModules.length} hidden booster${pluralization}`;

    return (
        <>
            <div className='width-fit-content'>
                <Button
                    variant='text-secondary'
                    isFullWidth={false}
                    onClick={() => setIsExpanded(!isExpanded)}
                    noPadding={true}
                >
                    {toggleLabel}
                </Button>
            </div>
            {/* @ts-expect-error */}
            <CollapseExpandAnimation isExpanded={isExpanded} animateOnMount={true}>
                <Stack spacing={16}>
                    {props.hiddenModules.map((module) => (
                        <OnboardingModule
                            key={module.type}
                            module={module}
                            hasFullSchedulerAccess={props.hasFullSchedulerAccess}
                            isAdmin={NutClientConfig.loggedInUserIsAdmin}
                            userEmailCalendarStatuses={props.userEmailCalendarStatuses}
                            onboardingQuotes={null}
                            userVideoIntegrations={props.userVideoIntegrations}
                            variant='customer'
                            onEmailCalendarAuthSuccess={props.onEmailCalendarAuthSuccess}
                        />
                    ))}
                </Stack>
            </CollapseExpandAnimation>
        </>
    );
}
